// extracted by mini-css-extract-plugin
export var configurationSection = "_zd-0";